const { makeStyles } = require('@material-ui/core');

export const planoComercialStyles = makeStyles(() => ({
  Container: {
    justifyContent: 'center',
  },
  PaperClass: {
    maxHeight: 510,
  },
}));
